export const ADMIN_FETCH_FAV_PAGE_SUCCESS = 'ADMIN_FETCH_FAV_PAGE_SUCCESS';
export const ADMIN_RESET_FAV_PAGE_M = 'ADMIN_RESET_FAV_PAGE_M';
